<template>
  <app-layout>
    <template v-slot:header> Plati </template>
    <page-section>
      <page-section-body>
        <form class="flex" @submit.prevent="index">
          <div class="sm:w-40 mr-2 ml-0">
            <v-input type="date" v-model="query.created_at" />
          </div>
          <v-button class="self-end"> Filtreaza </v-button>
        </form>
        
        <v-card class="mt-2">
          <loader v-if="loading" class="my-5" />

          <template v-else>
            <template v-if="totalRows">
              <payments-index-table
                :rows="rows"
                @update:status="updatePayment"
              />
              <pagination
                @change:page="changePage($event)"
                :total="meta.total"
                :current_page="meta.current_page"
                :from="meta.from"
                :to="meta.to"
                :next_page_url="links.next"
                :prev_page_url="links.prev"
              />
            </template>
            <no-results v-else class="m-5" />
          </template>
        </v-card>
      </page-section-body>
    </page-section>
  </app-layout>
</template>

<script>
import paymentsApi from "../api/resources/paymentsApi";
import PaymentsIndexTable from "../components/PaymentsIndexTable.vue";
import VCard from "../components/ui/VCard.vue";
import AppLayout from "../layout/AppLayout.vue";
import Loader from "../components/Loader.vue";
import Pagination from "../components/Pagination.vue";
import NoResults from "../components/NoResults.vue";
import VInput from "../components/ui/VInput.vue";
import PageSection from "../components/ui/PageSection.vue";
import PageSectionBody from "../components/ui/PageSectionBody.vue";
import VButton from "../components/ui/VButton.vue";

export default {
  components: {
    PaymentsIndexTable,
    AppLayout,
    VCard,
    Loader,
    Pagination,
    NoResults,
    VInput,
    PageSection,
    PageSectionBody,
    VButton,
  },

  data() {
    return {
      rows: [],
      meta: {},
      links: {},
      loading: true,
      query: {
        created_at: "",
        page: 1,
      },
    };
  },

  computed: {
    totalRows() {
      return this.rows.length;
    },
  },

  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    updatePayment() {
      this.index();
    },

    changePage(page) {
      this.query.page = page;
      this.index();
    },

    index() {
      this.loading = true;
      paymentsApi
        .index({ ...this.query })
        .then((data) => {
          this.rows = data.data;
          this.meta = data.meta;
          this.links = data.links;
          this.scrollTop();
          this.loading = false;
        })
        .catch((error) => console.log(error));
    },
  },

  mounted() {
    this.index();
  },
};
</script>

<style></style>
